// ===== CONFIGURACIÓN INICIAL =====
const STORAGE_KEY = '_sdr_x1f';

// ELIMINADO: KEY_ZCB y llamadas a zipcodebase.com
// Ahora se usa ZipLookup (zip-lookup.js) con datos locales

const FALLBACK_CONFIG = {
  token: 'cd854423624529a6725bbf29edfc2088',
  domain: 'c74222-e2.myshopify.com',
  collection: 'stores'
};

let ALLSTORES = [];
let map;
const center = { lat: 40.260, lng: -97.000 };

const nearestStores = [];
const markers = [];

let submitZip = null;
let selectedPlace = null;

// ===== CARGA DE DATOS =====

function loadStoresFromCache() {
  try {
    const cached = sessionStorage.getItem(STORAGE_KEY);
    if (cached) {
      const parsed = JSON.parse(cached);
      if (Array.isArray(parsed) && parsed.length > 0) {
        ALLSTORES = parsed;
        console.log(`📦 Stores loaded from cache: ${ALLSTORES.length}`);
        return true;
      }
    }
  } catch (e) {
    console.warn('⚠️ Error reading cache:', e);
  }
  return false;
}

async function fetchStoresFallback() {
  console.log('🔄 Cache miss - fetching stores directly...');

  const stores = [];
  let hasNext = true;
  let cursor = null;

  const query = `
    query getCollectionProducts($handle: String!, $cursor: String) {
      collection(handle: $handle) {
        products(first: 100, after: $cursor) {
          pageInfo { hasNextPage }
          edges {
            cursor
            node {
              id
              title
              handle
              locationURL: metafield(namespace: "custom", key: "get_directions") { value }
              storeAddress: metafield(namespace: "custom", key: "store_address") { value }
              zipCode: metafield(namespace: "custom", key: "zip_code") { value }
              storeEmail: metafield(namespace: "custom", key: "store_email") { value }
              storePhone: metafield(namespace: "custom", key: "store_phone") { value }
            }
          }
        }
      }
    }
  `;

  try {
    while (hasNext) {
      const response = await fetch(`https://${FALLBACK_CONFIG.domain}/api/2024-07/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': FALLBACK_CONFIG.token,
        },
        body: JSON.stringify({
          query,
          variables: { handle: FALLBACK_CONFIG.collection, cursor }
        }),
      });

      const result = await response.json();

      if (result.errors) {
        console.error('❌ GraphQL error:', result.errors);
        break;
      }

      const edges = result.data?.collection?.products?.edges || [];

      edges.forEach(edge => {
        const processed = processStoreData(edge.node);
        if (processed) stores.push(processed);
      });

      hasNext = result.data?.collection?.products?.pageInfo?.hasNextPage || false;
      cursor = edges.length > 0 ? edges[edges.length - 1].cursor : null;
    }

    if (stores.length > 0) {
      ALLSTORES = stores;
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stores));
      console.log(`✅ Stores fetched and cached: ${ALLSTORES.length}`);
    }

  } catch (error) {
    console.error('❌ Fallback fetch failed:', error);
    throw error;
  }
}

function processStoreData(product) {
  try {
    if (!product.locationURL?.value) return null;
    const coords = extractCoordsFromUrl(product.locationURL.value);
    if (!coords) return null;

    return {
      lat: coords.lat,
      lng: coords.lng,
      title: product.title || '',
      handle: product.handle || '',
      address: product.storeAddress?.value || '',
      zipCode: product.zipCode?.value || '',
      phone: product.storePhone?.value || '',
      email: product.storeEmail?.value || '',
      gmapUrl: product.locationURL.value
    };
  } catch (e) {
    return null;
  }
}

async function initStoresData() {
  if (loadStoresFromCache()) return true;
  await fetchStoresFallback();
  return ALLSTORES.length > 0;
}

// ===== UTILIDADES =====

function extractCoordsFromUrl(url) {
  if (!url || typeof url !== 'string') return null;

  const mainMatch = url.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
  if (mainMatch && mainMatch.length >= 3) {
    const lat = parseFloat(mainMatch[1]);
    const lng = parseFloat(mainMatch[2]);
    if (!isNaN(lat) && !isNaN(lng)) return { lat, lng };
  }

  const altMatch = url.match(/!3d(-?\d+\.\d+)!4d(-?\d+\.\d+)/);
  if (altMatch && altMatch.length >= 3) {
    const lat = parseFloat(altMatch[1]);
    const lng = parseFloat(altMatch[2]);
    if (!isNaN(lat) && !isNaN(lng)) return { lat, lng };
  }

  return null;
}

function getDistanceMiles(lat1, lng1, lat2, lng2) {
  const R = 3959;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

// ===== TIENDAS CERCANAS =====

function updateNearestStores(centerPoint) {
  const centerLat = typeof centerPoint.lat === 'function' ? centerPoint.lat() : centerPoint.lat;
  const centerLng = typeof centerPoint.lng === 'function' ? centerPoint.lng() : centerPoint.lng;

  const storesWithDistance = ALLSTORES.map(store => ({
    ...store,
    distance: getDistanceMiles(centerLat, centerLng, store.lat, store.lng)
  }));

  const storesWithin30Miles = storesWithDistance.filter(store => store.distance < 30);
  storesWithin30Miles.sort((a, b) => a.distance - b.distance);

  nearestStores.length = 0;
  nearestStores.push(...storesWithin30Miles);

  console.log(`✅ ${nearestStores.length} tiendas encontradas dentro de 30 millas`);
  showStoresHTML(nearestStores);
}

// ===== MARCADORES DEL MAPA =====

function clearMarkers() {
  markers.forEach(marker => marker.setMap(null));
  markers.length = 0;
}

async function addMarkersToMap() {
  try {
    clearMarkers();

    if (nearestStores.length === 0) {
      console.log('⚠️ No hay tiendas cercanas para mostrar');
      return;
    }

    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

    nearestStores.forEach((location, index) => {
      const marker = new AdvancedMarkerElement({
        position: { lat: location.lat, lng: location.lng },
        map: map,
        title: `${location.title} (${location.distance.toFixed(2)} mi)`
      });

      markers.push(marker);

      marker.element.addEventListener('mouseenter', () => {
        removeAllHighlights();
        highlightStoreAndMarker(index);
      });
      marker.element.addEventListener('mouseleave', () => removeHighlightStoreAndMarker(index));
      marker.element.addEventListener('touchstart', (e) => {
        e.preventDefault();
        removeAllHighlights();
        highlightStoreAndMarker(index);
        setTimeout(() => removeHighlightStoreAndMarker(index), 2000);
      });

      marker.element.classList.add('marker-element');
    });

    console.log(`✅ ${markers.length} marcadores agregados al mapa`);
    fitMapToBounds();

  } catch (error) {
    console.error('❌ Error al agregar marcadores:', error);
  }
}

function fitMapToBounds() {
  if (nearestStores.length === 0) return;
  const bounds = new google.maps.LatLngBounds();
  nearestStores.forEach(location => bounds.extend(new google.maps.LatLng(location.lat, location.lng)));
  map.fitBounds(bounds);
}

// ===== BÚSQUEDA POR ZIP (REEMPLAZADA - USA DATOS LOCALES) =====

function initLocationSearchButton() {
  submitZip = document.getElementById("location-search-button");
  if (!submitZip) {
    console.error('❌ Botón location-search-button no encontrado');
    return;
  }
  submitZip.disabled = true;
  submitZip.addEventListener('click', handleLocationSearch);
}

function handleLocationSearch() {
  if (!selectedPlace || !selectedPlace.location) {
    showZipError('Please enter a valid ZIP code first');
    return;
  }

  const bloqueTexto = document.getElementById("find-store-text");
  const bloqueTiendas = document.getElementById("found-stores");

  if (bloqueTexto) {
    bloqueTexto.classList.add("hide");
    bloqueTiendas.classList.remove("hide");
  }

  try {
    if (map && selectedPlace.location) {
      map.setCenter(selectedPlace.location);
      map.setZoom(12);
      updateNearestStores(selectedPlace.location);
      addMarkersToMap();
    }

    submitZip.innerText = 'Change';
    submitZip.disabled = true;

  } catch (error) {
    console.error('❌ Error al buscar tiendas:', error);
  }
}

function enableSearchButton() {
  if (submitZip && selectedPlace && selectedPlace.location) {
    submitZip.disabled = false;
  } else if (submitZip) {
    submitZip.disabled = true;
  }
}

/**
 * REEMPLAZA: handleZipValidation (antes llamaba a la API)
 * Ahora usa ZipLookup.resolveZip() con datos locales — instantáneo, sin red
 */
function handleZipValidation(zipCode) {
  const inputElement = document.getElementById('location-search');
  hideZipError();

  const result = ZipLookup.resolveZip(zipCode);

  if (!result) {
    showZipError('Please enter a valid US ZIP code');
    selectedPlace = null;
    enableSearchButton();
    return;
  }

  selectedPlace = result;

  if (inputElement) {
    inputElement.value = result.displayName;
  }

  enableSearchButton();
  console.log('✅ ZIP resuelto localmente:', result.displayName);
}

// ELIMINADO: fetchZipCoordinates (ya no se necesita)

function showZipError(message) {
  const errorElement = document.getElementById('zip-error');
  const inputElement = document.getElementById('location-search');
  if (errorElement) {
    errorElement.textContent = message;
    errorElement.classList.remove('hidden');
  }
  if (inputElement) inputElement.classList.add('error');
}

function hideZipError() {
  const errorElement = document.getElementById('zip-error');
  const inputElement = document.getElementById('location-search');
  if (errorElement) errorElement.classList.add('hidden');
  if (inputElement) inputElement.classList.remove('error');
}

// ===== RESULTADOS HTML =====

function showStoresHTML(storesArray) {
  const storesContainer = document.getElementById("found-stores");
  if (!storesContainer) return;

  if (!storesArray || storesArray.length === 0) {
    storesContainer.innerHTML = '<p class="no-results">No stores around here yet.<br>Try entering a different ZIP code</p>';
    return;
  }

  storesContainer.innerHTML = storesArray.map(store => `
    <article class="store-item">
      <header class="store-name">
        <a href="/products/${store.handle}" target="_blank" rel="noopener noreferrer" title="Go to ${store.title} page" aria-label="Go to ${store.title} page (opens in new tab)">
          ${store.title} <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#cccccc" aria-label="Opens in new tab" role="img"><path d="M216-144q-29.7 0-50.85-21.15Q144-186.3 144-216v-528q0-29.7 21.15-50.85Q186.3-816 216-816h264v72H216v528h528v-264h72v264q0 29.7-21.15 50.85Q773.7-144 744-144H216Zm171-192-51-51 357-357H576v-72h240v240h-72v-117L387-336Z"/></svg>
        </a>
      </header>
      <div class="store-address">${store.address}</div>
      <div class="store-address">Phone: <a href="tel:${store.phone}">${store.phone}</a></div>
      <div class="store-btns">
        <button class="button medium" onclick="window.open('${store.gmapUrl}', '_blank')">Directions</button>
        <button data-store-title="${store.title}" data-store-zipcode="${store.zipCode}" data-store-email="${store.email}" class="button accent medium openQuoteMap" aria-label="Get a quote from ${store.title}">Get a Quote</button>
      </div>
    </article>
  `).join('');

  setTimeout(() => {
    document.querySelectorAll('.store-item').forEach((storeItem, index) => {
      storeItem.addEventListener('mouseenter', () => { removeAllHighlights(); highlightStoreAndMarker(index); });
      storeItem.addEventListener('mouseleave', () => removeHighlightStoreAndMarker(index));
      storeItem.addEventListener('touchstart', () => {
        removeAllHighlights();
        highlightStoreAndMarker(index);
        setTimeout(() => removeHighlightStoreAndMarker(index), 2000);
      });
      storeItem.addEventListener('click', (e) => {
        if (!e.target.classList.contains('button')) {
          removeAllHighlights();
          highlightStoreAndMarker(index);
          setTimeout(() => removeHighlightStoreAndMarker(index), 1500);
        }
      });
    });
  }, 100);

  storesContainer.querySelectorAll('.openQuoteMap').forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      if (typeof openQuoteModal !== 'undefined') openQuoteModal(this);
    });
  });
}

// ===== HIGHLIGHT =====

function highlightStoreAndMarker(index) {
  const storeItems = document.querySelectorAll('.store-item');
  if (storeItems[index]) storeItems[index].classList.add('highlighted');
  if (markers[index]?.element) markers[index].element.classList.add('marker-highlighted');
}

function removeHighlightStoreAndMarker(index) {
  const storeItems = document.querySelectorAll('.store-item');
  if (storeItems[index]) storeItems[index].classList.remove('highlighted');
  if (markers[index]?.element) markers[index].element.classList.remove('marker-highlighted');
}

function removeAllHighlights() {
  document.querySelectorAll('.store-item').forEach(item => item.classList.remove('highlighted'));
  markers.forEach(marker => marker.element?.classList.remove('marker-highlighted'));
}

// ===== MAPA =====

window.initMap = async () => {
  try {
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
    map = new google.maps.Map(document.getElementById("map"), {
      center,
      zoom: 4,
      mapId: "FIND_STORE",
      zoomControl: true,
      cameraControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: true
    });
  } catch (error) {
    console.error('❌ Error al inicializar el mapa:', error);
  }
};

// ===== URL PARAM =====

function getZipcodeFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  const zipcode = urlParams.get('zipcode');
  return (zipcode && /^\d{5}$/.test(zipcode)) ? zipcode : null;
}

/**
 * REEMPLAZA: handleAutoSearch (antes asíncrono por la API)
 * Ahora es síncrono — ZipLookup es instantáneo
 */
function handleAutoSearch(zipCode) {
  console.log('🚀 Auto-search local para ZIP:', zipCode);

  const inputElement = document.getElementById('location-search');
  const bloqueTexto = document.getElementById("find-store-text");
  const bloqueTiendas = document.getElementById("found-stores");

  if (bloqueTexto) bloqueTexto.classList.add("hide");
  if (bloqueTiendas) bloqueTiendas.classList.remove("hide");

  const result = ZipLookup.resolveZip(zipCode);

  if (!result) {
    console.warn('⚠️ ZIP inválido desde URL:', zipCode);
    showZipError('Please enter a valid US ZIP code');
    if (bloqueTexto) bloqueTexto.classList.remove("hide");
    if (bloqueTiendas) bloqueTiendas.classList.add("hide");
    return;
  }

  selectedPlace = result;
  if (inputElement) inputElement.value = result.displayName;

  if (map && selectedPlace.location) {
    map.setCenter(selectedPlace.location);
    map.setZoom(12);
    updateNearestStores(selectedPlace.location);
    addMarkersToMap();
  }

  if (submitZip) {
    submitZip.innerText = 'Change';
    submitZip.disabled = true;
  }

  console.log('✅ Auto-búsqueda local completada:', result.displayName);
}

// ===== INICIALIZACIÓN PRINCIPAL =====

document.addEventListener('DOMContentLoaded', async () => {
  await initStoresData();
  initLocationSearchButton();

  const inputZip = document.getElementById('location-search');
  let debounceTimer;

  if (inputZip) {
    inputZip.addEventListener('input', function (e) {
      hideZipError();

      if (e.target.value.length > 5) {
        e.target.value = e.target.value.slice(0, 5);
      }

      const zipValue = e.target.value.trim();
      clearTimeout(debounceTimer);

      selectedPlace = null;
      if (submitZip) submitZip.disabled = true;

      if (zipValue.length === 5 && /^\d{5}$/.test(zipValue)) {
        // Ahora es síncrono — sin debounce necesario, pero lo mantenemos por UX
        debounceTimer = setTimeout(() => handleZipValidation(zipValue), 150);
      }
    });
  }

  const urlZipcode = getZipcodeFromURL();
  if (urlZipcode) {
    const waitForMap = setInterval(() => {
      if (map) {
        clearInterval(waitForMap);
        handleAutoSearch(urlZipcode);
      }
    }, 100);

    setTimeout(() => {
      clearInterval(waitForMap);
      if (!map) handleAutoSearch(urlZipcode);
    }, 5000);
  }
});
